export default {
  _route: {
    Home: "Home",
    Login: "Login",
    ErrorLogger: "Error Logger",
    Profile: "My Profile",
    MessageCenter: "Message Center",
    Components: "Components",
    CountToDemo: "CountTo",
    ClipperDemo: "Images Clipper",
    SplitPaneDemo: "Split Pane",
    OrgTreeDemo: "Org Structure Tree",
    AnimationMixinDemo: "Animation Mixin",
    DraggableListDemo: "List Drag",
    DraggableItemDemo: "Item Drag",
    DraggableDialogDemo: "Dialog Drag",
    DragDrawerDemo: "Drawer Drag",
    TinymceDemo: "Tinymce",
    WangEditorDemo: "Wang Editor",
    CodeMirrorDemo: "Code Mirror",
    InfoSelectionDemo: "Info Selection",
    Table: "Table",
    DragTable: "Drag Table",
    DynamicTable: "Dynamic Table",
    InlineTable: "Inline Table",
    SearchTable: "Search Table",
    PageTable: "Page Table",
    IntegrationTable: "Integration Table",
    Excel: "Excel",
    ExportExcel: "Export Excel",
    SelectExcel: "Select Excel",
    MergeHeader: "Merge Header",
    UploadExcel: "Upload Excel",
    Clipboard: "Clipboard",
    Icons: "Icons",
    Permission: "Permission",
    SwitchPermission: "Switch Permission",
    RolePermission: "Role Permission",
    Nested: "Nested Route",
    Menu1: "menu 1",
    "Menu1-1": "menu 1-1",
    "Menu1-2": "menu 1-2",
    "Menu1-3": "menu 1-3",
    "Menu1-3-1": "menu 1-3-1",
    "Menu1-3-2": "menu 1-3-2",
    Menu2: "menu 2",
    params: "params",
    query: "query",
  },
  _tagsNav: {
    refresh: "Refresh Page",
    close: "Close Current",
    closeOthers: "Close Others",
    closeAll: "Close All",
  },
  _headerBar: {
    changeLanguage: "Successfully modified the language！",
    changeSize: "Successfully modified the global size！",
    profile: "My Profile",
    settings: "My Settings",
    messageCenter: "My Message",
    logOut: "Log Out",
  },
  _settings: {
    layoutTitle: "Layout Style Settings",
    themeTitle: "Theme Style Settings",
    layoutComponents: "Layout Components Configuration",
    titleMode: "Browser Title Configuration",
    theme: "Theme",
    changeTheme: "Compiling the theme",
    showBreadcrumb: "Show Breadcrumb",
    showTagsNav: "Show TagsNav",
    recordTagsNav: "Cache Tabs Access",
    showLayoutLogo: "Show The Side Menu Logo",
    titleModeOne: "Project Title + Page Title",
    titleModeTwo: "User Name + Page Title",
    titleModeThree: "Project Title",
    titleModeFour: "Page Title",
    resetSettingsTitle: "Reset Settings",
    resetSettings: "Clearing Settings Cache And Refreshing",
  },
};
